import { Component, input, output } from '@angular/core';

import { TagItem } from '../../model/tag-item';
import { UrlLinkDirective } from '../url-link.directive';

/**
 * The `tag-item` partial: a filter value or a colour/size choice. An item with no text renders
 * nothing, and an active one has no link, exactly as in the Mustache version.
 */
@Component({
  selector: 'tag-item',
  imports: [UrlLinkDirective],
  host: {
    style: 'display: contents'
  },
  template: `
    @if (item().text) {
      <a [storefrontUrl]="item().uri" [keepScroll]="keepScroll()" [class]="classes()"
         (navigated)="chosen.emit($event)">
        {{item().text}}
      </a>
    }
    `
})
export class TagItemComponent {

  readonly item = input.required<TagItem>();

  readonly keepScroll = input(false);

  readonly chosen = output<string>();

  classes() {
    const item = this.item();
    return 'tag-item'
      + (item.active ? ' active unselectable' : '')
      + (item.disabled ? ' bg8 unselectable' : '');
  }

}
